import * as z from 'zod';

export const MAX_USERNAME_LENGTH = 13;

export const rules = {
  username: z
    .string({ message: 'This field is required' })
    .min(4, 'Must be at least 4 characters')
    .max(MAX_USERNAME_LENGTH, `Must be at most ${MAX_USERNAME_LENGTH} characters`)
    .regex(/^[0-9a-z]*$/i, 'Not a valid username'),

  email: z
    .string({ message: 'This field is required' })
    .regex(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/i,
      'Invalid email address',
    ),

  isAdult: z.boolean({ message: 'This field is required' }).refine((val) => val),

  isAgreeWithTnc: z.boolean().refine((val) => val),

  message: z.string({ message: 'This field is required' }).min(4, 'Must be at least 4 characters'),

  required: z.string({ message: 'This field is required' }),

  fullName: z.string({ message: 'This field is required' }).refine(
    (val) => {
      const [firstName, lastName] = val.split(' ');
      return Boolean(firstName && lastName);
    },
    { message: 'Must be a valid full name' },
  ),
};
